module.exports = __webpack_public_path__ + "media/images/common/2column_product_bg_nn-a9bf6c8d62b997ed0bbe1ee1edf82793.png";